import BucketApiRequest from "./BucketApiRequest";
import { GET_INDICATE_WHO } from "../ApiUrls";

export default class IndicateWhoRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_INDICATE_WHO;
  };
}
